import React, { FC, useRef, useState } from 'react';
import CheckBox from 'src/components/atoms/CheckBox';
import SurveyButton from 'src/components/atoms/buttons/SurveyButton';
import Handy from 'src/components/organisms/template/StepA/Question/Handy';
import SingleParent from 'src/components/organisms/template/StepA/Question/SingleParent';
import Women from 'src/components/organisms/template/StepA/Question/Women';
import LabelSelect from 'src/components/atoms/selectbox/LabelSelect';
import { familyDataStore } from 'src/store/familyInfo';
import { contentModalDep2ViewStore } from 'src/store/modal';
import {
  isResidentTaxpayer,
  isElderlyDeductionApplied,
  isChildTaxDeductionApplied,
  isBirthOrAdoptDeductionApplied,
  computeChildOrderCode,
} from 'src/utils/familyDeduction';
import { isHandySelect, childSelect } from 'src/static/typeCode';
import { getMemberInfo } from 'src/utils/common';
import './style.scss';

interface Props {
  state: any;
  setState: any;
  viewStatus: any;
}
const FamilyDescription: FC<Props> = ({ state, setState, viewStatus }) => {
  const checkTypeEvt = () => {};
  const userInfoData: any = getMemberInfo();
  const familyInitResult = familyDataStore((state: any) => state.payload);
  const familyInitBind = familyDataStore((state: any) => state.bindPayload);
  const familySet = familyDataStore((state: any) => state.result).data || [];

  const payload = state.payload || [];

  // 출산입양공제: 별도 저장 플래그 없이 화면 표시용으로만 매 렌더링마다 계산
  const isBirthOrAdoptDeductionChecked = () => {
    const isEleDeductFieldItem: any = payload.find((item: any) => item.id === 'is_ele_deduct');
    const familyTypeFieldItem: any = payload.find((item: any) => item.id === 'family_type');
    const resIdFieldItem: any = payload.find((item: any) => item.id === 'res_id');

    return isBirthOrAdoptDeductionApplied(
      {
        is_ele_deduct: isEleDeductFieldItem?.value,
        family_type: familyTypeFieldItem?.value,
        res_id: resIdFieldItem?.value,
      },
      userInfoData.acct_year
    );
  };

  // Modal Dep2
  const setContentModalDep2State = contentModalDep2ViewStore((state: any) => state.set);

  const checkSurvey = (status: string, field: string) => {
    const fieldItem: any = state.payload.find((item: any) => item.id === field) || {};
    fieldItem.value = status || 'N';
    setState({ payload: [...state.payload] });
    setContentModalDep2State({
      active: '',
    });
  };

  const checkClickEvt = (e: any, status: string, field?: string) => {
    if (viewStatus === 'view') return false;
    if (!field) return;
    const vType = status === 'on' ? 'N' : 'Y';

    // 부녀자 공제 / 한부모 공제는 체크박스 클릭 시 설문 모달을 오픈해서 값을 결정
    if (field === 'is_deduct_women') {
      familyQuestionSet('women');
      return;
    }
    if (field === 'is_deduct_single_parent') {
      familyQuestionSet('singleParent');
      return;
    }
    //기본공제
    if (field === 'is_ele_deduct') {
      const isEleDeducted = vType === 'Y';
      // 기본공제 체크 시 주민번호 기준으로 경로우대공제 재검토, 해제 시 경로우대/장애인공제 비활성화
      const resIdFieldItem: any = state.payload.find((item: any) => item.id === 'res_id');
      const resNum = resIdFieldItem?.value || '';

      const familyTypeFieldItem: any = state.payload.find((item: any) => item.id === 'family_type');
      const familyTypeValue = familyTypeFieldItem?.value || '';
      const familySeqidFieldItem: any = state.payload.find(
        (item: any) => item.id === 'family_seqid'
      );
      const residentTaxpayer = isResidentTaxpayer(userInfoData);
      const member = {
        is_ele_deduct: vType,
        family_type: familyTypeValue,
        res_id: resNum,
        family_seqid: familySeqidFieldItem?.value,
      };

      // 경로우대공제: 본인이면 거주자 여부와 무관하게 적용, 본인 외에는 소득자가 거주자인 경우에만 적용
      const isOldFieldItem: any = state.payload.find((item: any) => item.id === 'is_old');
      if (isOldFieldItem) {
        isOldFieldItem.value = isElderlyDeductionApplied(
          member,
          userInfoData.acct_year,
          residentTaxpayer
        )
          ? 'Y'
          : 'N';
      }

      const isHandyFieldItem: any = state.payload.find((item: any) => item.id === 'is_handy');
      if (isHandyFieldItem && !isEleDeducted) {
        isHandyFieldItem.value = '0';
        isHandyFieldItem.select = isHandySelect('0');
        isHandyFieldItem.text = isHandyFieldItem.select.checked?.value;
      }

      // 자녀세액공제: 기본공제 대상자 + 소득자(본인) 거주자 + 직계비속 자녀·입양자(4)/위탁아동(8) + 귀속연도 기준 만 8세 이상
      const childDeductionFieldItem: any = state.payload.find(
        (item: any) => item.id === 'child_deduction'
      );
      if (childDeductionFieldItem) {
        childDeductionFieldItem.value = isChildTaxDeductionApplied(
          member,
          userInfoData.acct_year,
          residentTaxpayer
        )
          ? 'Y'
          : 'N';
      }

      // 자녀구분(첫째/둘째/셋째이상): 주민번호(생년월일)로 직계비속 자녀 중 출생순서를 판정
      const childCdFieldItem: any = state.payload.find((item: any) => item.id === 'child_cd');
      if (childCdFieldItem) {
        const childCdValue = computeChildOrderCode(member, familySet);
        childCdFieldItem.value = childCdValue;
        childCdFieldItem.select = childSelect(childCdValue);
        childCdFieldItem.text = childCdFieldItem.select.checked?.value;
      }
    }

    const fieldItem: any = state.payload.find((item: any) => item.id === field) || {};
    fieldItem.value = vType;
    setState({ payload: [...state.payload] });
  };

  const checkDisableClickEvt = (e: any, status: string, field?: string) => {};

  const familyQuestionSet = (id: string) => {
    // 부녀자 공제
    if (id === 'women') {
      setContentModalDep2State({
        active: '_active',
        title: '부녀자 추가 공제',
        content: <Women checkSurvey={checkSurvey} id="is_deduct_women" />,
        styleDef: { width: '750px', height: '800px' },
      });
    }
    // 한부모 공제
    if (id === 'singleParent') {
      setContentModalDep2State({
        active: '_active',
        title: '한부모 추가 공제',
        content: <SingleParent checkSurvey={checkSurvey} id="is_deduct_single_parent" />,
        styleDef: { width: '750px', height: '800px' },
      });
    }
    // 장애인 공제
    if (id === 'handy') {
      setContentModalDep2State({
        active: '_active',
        title: '장애인 추가 공제',
        content: <Handy checkSurvey={checkSurvey} id="is_handy" />,
        styleDef: { width: '750px', height: '800px' },
      });
    }
  };

  const confirmSelectEvt = (item: any, field: string) => {
    const fieldItem = state.payload.find((fitem: any) => fitem.id === field) || {};

    fieldItem.select.checked = item;
    fieldItem.text = item.value;
    fieldItem.value = item.id;
    setState({ payload: [...state.payload] });
  };

  return (
    <div className="_family_info_description">
      <div className="_grid">
        <div className="_label">
          <div className="_col _col_a">
            <div className="_tit">공제 항목</div>
          </div>
          <div className="_col _col_b">
            <div className="_tit">항목 설명</div>
          </div>
        </div>

        <div className="_content">
          <div className="_row">
            <div className="_col _col_a">
              <div className="_cont _main_tit">
                <div className="_tit _h3">인적공제항목</div>
                <div className="_tit _h0">소득공제</div>
              </div>
            </div>
            <div className="_col _col_b">
              <div className="_row">
                <div className="_col _col_c">
                  <div className="_cont _btn_tit">
                    <div className="_btn">
                      <CheckBox
                        label=""
                        selected={
                          payload.find((item: any) => item.id === 'is_ele_deduct').value === 'Y'
                            ? 'on'
                            : 'off'
                        }
                        btnClickEvt={checkClickEvt}
                        field="is_ele_deduct"
                      />
                    </div>
                    <div className="_tit">기본 공제</div>
                  </div>
                </div>
                <div className="_col _col_d">
                  <div className="_cont">
                    <div className="_h2">1인당 150만원 공제</div>
                    <div className="_d1">1. 근로자 본인</div>
                    <div className="_d1">2. 소득 금액요건 *1 을 충족한 배우자</div>
                    <div className="_d1">
                      3. 생계를 같이하는 부양가족(직계존속, 직계비속, 형제자매, 수급자, 위탁아동) 등
                      연령 요건*2 및 소득금액요건을 갖춘 경우
                    </div>
                    <div className="_d2">
                      <div className="_tit">1. 소득 금액요건</div>
                      <div className="_desc">
                        연간 소득금액 100만원 이하(단, 근로소득만 있을 시 총급여액 기준 500만원
                        이하)
                      </div>
                    </div>
                    <div className="_d2">
                      <div className="_tit">2. 연령 요건</div>
                      <div className="_desc">만 20세 이하 또는 만 60세 이상</div>
                    </div>
                    <div className="_d2">
                      <div className="_tit">3. 생계 요건</div>
                      <div className="_desc">
                        근로자 본인 또는 동거가족(직계비속입양자 제외)이 취학, 질병의 요양 근무상
                        또는 사업자의 형편으로 일시 퇴거한 경우에는 아래 서류 제출
                        <br />- 일시 퇴거자 동거가족 상황표 <br />- 일시 퇴거의 사유별
                        서류(재학증명서, 요양증명서, 재직증명서 등)
                      </div>
                    </div>
                    <div className="_d2">
                      <div className="_tit">예외사항</div>
                      <div className="_desc">
                        - 소득세법에 따른 장애인일 경우 연령 요건을 적용하지 않음 <br />- 배우자 및
                        수급자의 경우 연령요건을 적용하지 않음 <br />- 배우자 및 직계비속의 경우
                        생계요건을 적용하지 않음. <br />- 위탁아동의 경우 연령요건은 만 18세 미만(단
                        기간이 연장된 경우 만 20세 이하)
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {/*  */}
              <div className="_row">
                <div className="_col _col_c">
                  <div className="_cont _btn_tit">
                    <div className="_btn">
                      <CheckBox
                        label=""
                        selected={
                          payload.find((item: any) => item.id === 'is_deduct_women').value === 'Y'
                            ? 'on'
                            : 'off'
                        }
                        btnClickEvt={checkClickEvt}
                        field="is_deduct_women"
                      />
                    </div>
                    <div className="_tit">부녀자 공제</div>
                  </div>
                  <div className="_btn_div _below">
                    <div className="_btn">
                      <SurveyButton
                        clickEvent={e => familyQuestionSet('women')}
                        queLabel="설문조사"
                        type="_t2"
                      />
                    </div>
                  </div>
                </div>
                <div className="_col _col_d">
                  <div className="_cont">
                    <div className="_h2">
                      근로자 본인(여성) 50만원 공제 (단, 한부모 공제와 중복적용 배제)
                    </div>
                    <div className="_d1">기본요건: 근로소득 금액 3천만원 이하인 여성</div>
                    <div className="_d1">
                      추가요건: 배우자가 있거나 세대 주 이면서 기본공제 대상의 부양가족이 있는
                      경우{' '}
                    </div>
                    <div className="_d2">
                      <div className="_tit">참고</div>
                      <div className="_desc">
                        배우자가 있는 경우 해당 배우자의 소득요건을 고려하지 않음
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {/*  */}
              <div className="_row">
                <div className="_col _col_c">
                  <div className="_cont _btn_tit">
                    <div className="_btn">
                      <CheckBox
                        label=""
                        selected={
                          payload.find((item: any) => item.id === 'is_deduct_single_parent')
                            .value === 'Y'
                            ? 'on'
                            : 'off'
                        }
                        btnClickEvt={checkClickEvt}
                        field="is_deduct_single_parent"
                      />
                    </div>
                    <div className="_tit">한부모 공제</div>
                  </div>
                  <div className="_btn_div _below">
                    <div className="_btn">
                      <SurveyButton
                        clickEvent={e => familyQuestionSet('singleParent')}
                        queLabel="설문조사"
                        type="_t2"
                      />
                    </div>
                  </div>
                </div>
                <div className="_col _col_d">
                  <div className="_cont">
                    <div className="_h2">
                      근로자 본인(여성) 100만원 공제 (단, 부녀자 공제와 중복적용 배제)
                    </div>
                    <div className="_d1">
                      배우자가 없는 자로서 기본공제대상 직계비속, 입양자가 있는자
                    </div>
                  </div>
                </div>
              </div>
              {/*  */}
              <div className="_row">
                <div className="_bg"></div>
                <div className="_col _col_c">
                  <div className="_cont _btn_tit">
                    <div className="_btn">
                      <CheckBox
                        label=""
                        selected={
                          payload.find((item: any) => item.id === 'is_old').value === 'Y'
                            ? 'on'
                            : 'off'
                        }
                        // selected={'off'}
                        btnClickEvt={checkClickEvt}
                        field="is_old"
                      />
                    </div>
                    <div className="_tit">경로우대 공제</div>
                  </div>
                </div>
                <div className="_col _col_d">
                  <div className="_cont">
                    <div className="_h2">1인당 100만원 공제</div>
                    <div className="_d1">만 70세 이상</div>
                  </div>
                </div>
              </div>
              {/*  */}
              <div className="_row" style={{ height: '150px' }}>
                <div className="_col _col_c">
                  <div className="_cont _select_tit">
                    <div className="_btn">
                      <div className="_tit">장애인 공제</div>
                      {viewStatus === 'view' ? (
                        <div className="_select">
                          {payload.find((item: any) => item.id === 'is_handy')?.select?.checked
                            ?.value || ''}
                        </div>
                      ) : (
                        <div className="_select">
                          <LabelSelect
                            label=""
                            select={payload.find((item: any) => item.id === 'is_handy')?.select}
                            boxStyleDef={{ width: '130px', marginLeft: '-4px' }}
                            styleDef={{ fontSize: '13px' }}
                            optionStyleDef={{ fontSize: '13px' }}
                            confirmEvent={confirmSelectEvt}
                            field={'is_handy'}
                          />
                        </div>
                      )}
                    </div>
                  </div>
                  <div className="_btn_div _below">
                    <div className="_btn">
                      <SurveyButton
                        clickEvent={e => familyQuestionSet('handy')}
                        queLabel="설문조사"
                        type="_t2"
                      />
                    </div>
                  </div>
                </div>
                <div className="_col _col_d">
                  <div className="_cont">
                    <div className="_h2">1인당 200만원 공제</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="_row">
            <div className="_col _col_a">
              <div className="_cont _main_tit">
                <div className="_tit _h3">인적공제항목</div>
                <div className="_tit _h0">세액공제</div>
              </div>
            </div>
            <div className="_col _col_b">
              {/*  */}
              <div className="_row">
                <div className="_bg"></div>
                <div className="_col _col_c">
                  <div className="_cont _btn_tit">
                    <div className="_btn">
                      <CheckBox
                        label=""
                        selected={
                          payload.find((item: any) => item.id === 'child_deduction')?.value === 'Y'
                            ? 'on'
                            : 'off'
                        }
                        btnClickEvt={checkClickEvt}
                        field="child_deduction"
                      />
                    </div>
                    <div className="_tit">자녀세액 공제</div>
                  </div>
                </div>
                <div className="_col _col_d">
                  <div className="_cont">
                    <div className="_h1">2인 이하인 경우:1인당 15만원</div>
                    <div className="_h2">
                      2인을 초과하는 경우 : 30만원(2인까지) * 2인을 초과하는 1인당 30만원 공제
                    </div>
                    <div className="_d1">
                      연령요건과 소득요건을 갖춘 기본공제대상자인 만 8세이상 자녀
                    </div>
                  </div>
                </div>
              </div>
              {/*  */}
              <div className="_row">
                <div className="_bg"></div>
                <div className="_col _col_c">
                  <div className="_cont _btn_tit">
                    <div className="_btn">
                      <CheckBox
                        label=""
                        selected={isBirthOrAdoptDeductionChecked() ? 'on' : 'off'}
                        btnClickEvt={checkDisableClickEvt}
                        field="birthDeduction"
                      />
                    </div>
                    <div className="_tit">출산입양 공제</div>
                  </div>
                </div>
                <div className="_col _col_d">
                  <div className="_cont">
                    <div className="_h2">1인당 첫째 30만원, 둘째 50만원, 셋째이상 70만원 공제</div>
                    <div className="_d1">해당 과세기간에 출생한 기본공제대상자인 자녀</div>
                  </div>
                </div>
              </div>
              {/*  */}
              <div className="_row">
                {/* <div className="_row _disabled"> */}
                <div className="_bg"></div>
                <div className="_col _col_c">
                  <div className="_cont _select_tit">
                    <div className="_btn">
                      <div className="_tit">자녀 공제</div>
                      {viewStatus === 'view' ? (
                        <div className="_select">
                          {payload.find((item: any) => item.id === 'child_cd')?.select?.checked
                            ?.value || ''}
                        </div>
                      ) : (
                        <div className="_select">
                          <LabelSelect
                            label=""
                            select={payload.find((item: any) => item.id === 'child_cd')?.select}
                            boxStyleDef={{ width: '130px', marginLeft: '-4px' }}
                            styleDef={{ fontSize: '13px' }}
                            optionStyleDef={{ fontSize: '13px' }}
                            confirmEvent={confirmSelectEvt}
                            field={'child_cd'}
                          />
                        </div>
                      )}
                    </div>
                  </div>
                </div>
                <div className="_col _col_d">
                  <div className="_cont">
                    <div className="_h2">1인당 첫째 30만원, 둘째 50만원, 셋째이상 70만원 공제</div>
                    <div className="_d1">해당 과세기간에 출생한 기본공제대상자인 자녀</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FamilyDescription;
